import React from "react";

export default function CollageForm(props) {
    return <>
        <div className="modal modal-blur fade" id="modal-report" tabIndex="-1" role="dialog" aria-hidden="true">
            <div className="modal-dialog modal-lg" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Collage Form</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"/>
                    </div>
                    <div className="modal-body">
                        <div className="row">
                            <div className="mb-3 form-group col-md-12">
                                <label className="form-label">Collage Name</label>
                                <input
                                    name="COLLEGE"
                                    className="form-control"
                                    id="COLLEGE"
                                    value={props.formData.COLLEGE}
                                    onChange={props.onEdit}
                                    placeholder="Collage Name"
                                />
                            </div>

                            <div className="mb-3 form-group col-md-6">
                                <label className="form-label">Code</label>
                                <input
                                    name="COL_CODE"
                                    className="form-control"
                                    id="COL_CODE"
                                    value={props.formData.COL_CODE}
                                    onChange={props.onEdit}
                                    placeholder="Collage Code"
                                />

                            </div>

                            <div className="mb-3 form-group col-md-6">
                                <label className="form-label">Location</label>
                                <input
                                    name="COL_LOCATION"
                                    className="form-control"
                                    id="COL_LOCATION"
                                    value={props.formData.COL_LOCATION}
                                    onChange={props.onEdit}
                                    placeholder="Collage Location"
                                />

                            </div>

                            <div className="mb-3 form-group col-md-6">
                                <label className="form-label">Phone Number</label>
                                <input
                                    name="COL_PHONE"
                                    className="form-control"
                                    id="COL_PHONE"
                                    value={props.formData.COL_PHONE}
                                    onChange={props.onEdit}
                                    placeholder="Collage Phone"
                                />

                            </div>

                            <div className="mb-3 form-group col-md-6">
                                <label className="form-label">Status</label>
                                <select className="form-control" name="COL_STATUS" id="COL_STATUS" value={props.formData.COL_STATUS} onChange={props.onEdit}>
                                    <option value="">Select Status</option>
                                    <option value="1">Active</option>
                                    <option value="0">In-Active</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <a href="#" id="closeModal" className="btn btn-link link-secondary" data-bs-dismiss="modal">
                            Cancel
                        </a>
                        {
                            props.IsFormLoading ?
                                <button type="button" className="btn btn-primary ms-auto">
                                    <span><span className="spinner-border spinner-border-sm me-2" role="status"/> Please wait...</span>
                                </button>
                                :
                                <button type="button" onClick={props.onSubmit} className="btn btn-primary ms-auto">
                                            <span>
                                            <svg xmlns="http://www.w3.org/2000/svg" className="icon" width="24"
                                                 height="24"
                                                 viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none"
                                                 strokeLinecap="round" strokeLinejoin="round">
                                            <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                                            <line x1="12" y1="5" x2="12" y2="19"/>
                                            <line x1="5" y1="12" x2="19" y2="12"/>
                                        </svg>
                                             Submit
                                        </span>
                                </button>
                        }
                    </div>
                </div>
            </div>
        </div>
    </>
}